<template>
  <div>
    <div class="mb-3">
      <pre>&nbsp;</pre>
    </div>
    <div class="d-flex flex-wrap">
      <iframe
        width="640"
        height="480"
        v-bind:src="
          'https://www.youtube.com/embed/' + youtube.id + '?controls=0'
        "
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { db } from "./main";

export default {
  name: "Live",
  data() {
    return {
      youtube: {}
    };
  },
  firestore() {
    return {
      youtube: db ? db.collection("live").doc("youtube") : {}
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped></style>
